export const addressVerificationAnalytics = {
  trackBannerCloseClick: applicationId => {
    window.analytics.track('AddressVerificationBannerCloseClick', {
      application_id: applicationId,
    });
  },

  trackBannerRequestAccessClick: applicationId => {
    window.analytics.track('AddressVerificationBannerRequestAccessClick', {
      application_id: applicationId,
    });
  },

  trackBannerDocumentationClick: applicationId => {
    window.analytics.track('AddressVerificationBannerDocumentationClick', {
      application_id: applicationId,
    });
  },

  trackProTipDismiss: applicationId => {
    window.analytics.track('AddressVerificationProTipDismiss', {
      application_id: applicationId,
    });
  },

  trackProTipClick: applicationId => {
    window.analytics.track('AddressVerificationProTipClick', {
      application_id: applicationId,
    });
  },
};
